<template>
  <b-card no-body class="mb-3 shadow-sm log-card" :class="`border-${variant}`">
    <div class="d-flex align-items-center px-3 py-2" :class="`bg-${variant} text-white`">
      <b-icon :icon="icon" class="mr-2" font-scale="1.2" />
      <strong>{{ title }}</strong>
      <small class="ml-auto text-nowrap">{{ date }}</small>
    </div>

    <b-card-body class="px-3 py-2">
      <div class="log-details">
        <slot />
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  props: {
    variant: { type: String, required: true },
    icon: { type: String, required: true },
    title: { type: String, required: true },
    date: { type: String, default: '' },
  },
}
</script>

<style scoped>
.log-card {
  border-width: 0;
  border-left-width: 4px;
  overflow: hidden;
}

.log-details {
  font-size: 0.9rem;
}

.log-details >>> .log-row {
  display: flex;
  align-items: center;
  padding: 3px 0;
}

.log-details >>> .log-icon {
  width: 20px;
  flex-shrink: 0;
  margin-right: 8px;
}
</style>
